import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SystemUpdateIcon(props: IconProps) {
    return <Icon {...props} iconKey={"system_update"}/>
}
